import React, { useEffect, useState } from 'react';
import './BookDynoForm.css';

const UNDEFINED = '- Undefined -';

const YEAR_OPTIONS = Array.from({ length: 2027 - 1950 + 1 }, (_, i) => String(2027 - i));

// Make values are verbatim MakeName values from prod_system_catalogs.sema_Make.
// Casing matters. Do not "correct" INFINITI, Mini, or Ram.
const MAKE_OPTIONS = [
  { value: 'Acura', label: 'Acura' },
  { value: 'Alfa Romeo', label: 'Alfa Romeo' },
  { value: 'Aston Martin', label: 'Aston Martin' },
  { value: 'Audi', label: 'Audi' },
  { value: 'Bentley', label: 'Bentley' },
  { value: 'BMW', label: 'BMW' },
  { value: 'Buick', label: 'Buick' },
  { value: 'Cadillac', label: 'Cadillac' },
  { value: 'Chevrolet', label: 'Chevrolet' },
  { value: 'Chrysler', label: 'Chrysler' },
  { value: 'Dodge', label: 'Dodge' },
  { value: 'Ferrari', label: 'Ferrari' },
  { value: 'Fiat', label: 'Fiat' },
  { value: 'Ford', label: 'Ford' },
  { value: 'Genesis', label: 'Genesis' },
  { value: 'GMC', label: 'GMC' },
  { value: 'Honda', label: 'Honda' },
  { value: 'Hummer', label: 'Hummer' },
  { value: 'Hyundai', label: 'Hyundai' },
  { value: 'INFINITI', label: 'Infiniti' },
  { value: 'Isuzu', label: 'Isuzu' },
  { value: 'Jaguar', label: 'Jaguar' },
  { value: 'Jeep', label: 'Jeep' },
  { value: 'Kia', label: 'Kia' },
  { value: 'Lamborghini', label: 'Lamborghini' },
  { value: 'Land Rover', label: 'Land Rover' },
  { value: 'Lexus', label: 'Lexus' },
  { value: 'Lincoln', label: 'Lincoln' },
  { value: 'Lotus', label: 'Lotus' },
  { value: 'Lucid', label: 'Lucid' },
  { value: 'Maserati', label: 'Maserati' },
  { value: 'Mazda', label: 'Mazda' },
  { value: 'McLaren', label: 'McLaren' },
  { value: 'Mercedes-Benz', label: 'Mercedes-Benz' },
  { value: 'Mercury', label: 'Mercury' },
  { value: 'Mini', label: 'Mini' },
  { value: 'Mitsubishi', label: 'Mitsubishi' },
  { value: 'Nissan', label: 'Nissan' },
  { value: 'Oldsmobile', label: 'Oldsmobile' },
  { value: 'Plymouth', label: 'Plymouth' },
  { value: 'Polestar', label: 'Polestar' },
  { value: 'Pontiac', label: 'Pontiac' },
  { value: 'Porsche', label: 'Porsche' },
  { value: 'Ram', label: 'Ram' },
  { value: 'Rivian', label: 'Rivian' },
  { value: 'Rolls-Royce', label: 'Rolls-Royce' },
  { value: 'Saab', label: 'Saab' },
  { value: 'Saturn', label: 'Saturn' },
  { value: 'Scion', label: 'Scion' },
  { value: 'Smart', label: 'Smart' },
  { value: 'Subaru', label: 'Subaru' },
  { value: 'Suzuki', label: 'Suzuki' },
  { value: 'Tesla', label: 'Tesla' },
  { value: 'Toyota', label: 'Toyota' },
  { value: 'Volkswagen', label: 'Volkswagen' },
  { value: 'Volvo', label: 'Volvo' },
  { value: UNDEFINED, label: 'Other / Not Listed' },
];

const BookDynoForm = ({ initialEmail = '' }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState(initialEmail || '');
  const [year, setYear] = useState('');
  const [make, setMake] = useState('');
  const [model, setModel] = useState('');
  const [otherVehicle, setOtherVehicle] = useState('');
  const [submodel, setSubmodel] = useState('');
  const [vin, setVin] = useState('');
  const [comment, setComment] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (initialEmail) {
      setEmail(initialEmail);
    }
  }, [initialEmail]);

  const isOther = make === UNDEFINED;

  const handleMakeChange = (e) => {
    const nextMake = e.target.value;
    setMake(nextMake);

    if (nextMake === UNDEFINED) {
      setModel(UNDEFINED);
    } else if (model === UNDEFINED) {
      setModel('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    const cleanedPhone = phone.replace(/\D/g, '');
    const cleanedVin = vin.trim().toUpperCase();
    let finalComment = comment;

    // Original Speedpoint behavior: preserve "other vehicle" in comment only.
    if (make === UNDEFINED && otherVehicle.trim() !== '') {
      finalComment = `Vehicle: ${otherVehicle.trim()}\n\n${comment}`;
    }

    // Server maps fields and creates the SpeedPointe customer + Twilio SMS.
    try {
      const res = await fetch('/webhooks/book-dyno', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          location: 'Diesel Down',
          first_name: firstName,
          last_name: lastName,
          phone: cleanedPhone,
          email,
          year,
          make,
          model,
          submodel,
          vin: cleanedVin,
          comment: finalComment,
        }),
      });

      if (!res.ok) {
        throw new Error('Submission failed');
      }

      setPhone(cleanedPhone);
      setComment(finalComment);
      setSubmitted(true);
    } catch (err) {
      console.error('Book Dyno form error:', err);
      setError('Submission failed. Call (901) 443-7461 if needed.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {!submitted && (
        <form
          id="sp_contact_form"
          className="sp-contact-form"
          onSubmit={handleSubmit}
        >
          <label htmlFor="sp_first_name">First Name:</label>
          <input
            type="text"
            id="sp_first_name"
            name="first_name"
            required
            minLength={2}
            maxLength={100}
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />

          <label htmlFor="sp_last_name">Last Name:</label>
          <input
            type="text"
            id="sp_last_name"
            name="last_name"
            required
            minLength={2}
            maxLength={100}
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />

          <label htmlFor="sp_phone">Phone:</label>
          <input
            type="tel"
            id="sp_phone"
            name="phone"
            required
            inputMode="numeric"
            autoComplete="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />

          <label htmlFor="sp_email">Email:</label>
          <input
            type="email"
            id="sp_email"
            name="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <label htmlFor="sp_year">Vehicle Year:</label>
          <select
            id="sp_year"
            name="year"
            required
            value={year}
            onChange={(e) => setYear(e.target.value)}
          >
            <option value="">--None--</option>
            {YEAR_OPTIONS.map((y) => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>

          <label htmlFor="sp_make">Vehicle Make:</label>
          <select
            id="sp_make"
            name="make"
            required
            value={make}
            onChange={handleMakeChange}
          >
            <option value="">--None--</option>
            {MAKE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>

          <label htmlFor="sp_model">Model:</label>
          <input
            type="text"
            id="sp_model"
            name="model"
            required
            maxLength={255}
            value={model}
            readOnly={isOther}
            onChange={(e) => setModel(e.target.value)}
          />

          <div
            id="sp_other_vehicle_wrap"
            style={{ display: isOther ? undefined : 'none' }}
          >
            <label htmlFor="sp_other_vehicle">Tell us the year, make, and model:</label>
            <input
              type="text"
              id="sp_other_vehicle"
              maxLength={200}
              placeholder="e.g. 2019 Genesis G70 3.3T"
              required={isOther}
              value={otherVehicle}
              onChange={(e) => setOtherVehicle(e.target.value)}
            />
          </div>

          <label htmlFor="sp_submodel">Submodel:</label>
          <input
            type="text"
            id="sp_submodel"
            name="submodel"
            maxLength={255}
            value={submodel}
            onChange={(e) => setSubmodel(e.target.value)}
          />

          <label htmlFor="sp_vin">VIN:</label>
          <input
            type="text"
            id="sp_vin"
            name="vin"
            required
            minLength={11}
            maxLength={17}
            autoComplete="off"
            value={vin}
            onChange={(e) => setVin(e.target.value.toUpperCase())}
          />

          <label htmlFor="sp_comment">
            <strong>What Packages, Modifications, or Services Are You Looking For?:</strong>
          </label>
          <textarea
            id="sp_comment"
            name="comment"
            rows={6}
            required
            maxLength={10000}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />

          <button type="submit" disabled={submitting}>
            {submitting ? 'Submitting...' : 'Submit'}
          </button>

          {error && <p className="sp-form-error">{error}</p>}
        </form>
      )}

      {submitted && (
        <div id="sp_thank_you">
          Thank you! Your submission has been received.
        </div>
      )}
    </>
  );
};

export default BookDynoForm;
